<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M10 2.25C14.2802 2.25006 17.75 5.71983 17.75 10C17.75 14.2802 14.2802 17.7499 10 17.75C7.36558 17.75 5.03891 16.4352 3.63965 14.4287C3.40297 14.089 3.48657 13.6217 3.82617 13.3848C4.16589 13.148 4.63322 13.2317 4.87012 13.5713C6.00083 15.1926 7.87661 16.25 10 16.25C13.4517 16.2499 16.25 13.4517 16.25 10C16.25 6.54825 13.4517 3.75006 10 3.75C7.87687 3.75004 6.00098 4.80821 4.87012 6.42871C4.63317 6.76823 4.16582 6.85192 3.82617 6.61523C3.48669 6.3783 3.40302 5.91092 3.63965 5.57129C5.03877 3.56606 7.3654 2.25004 10 2.25Z"
            fill="currentColor"
        />
        <path
            d="M8.46973 6.46973C8.76262 6.17683 9.23738 6.17683 9.53027 6.46973L12.5303 9.46973C12.5787 9.51812 12.616 9.5732 12.6484 9.62988C12.664 9.65703 12.6803 9.68375 12.6924 9.71289C12.7131 9.76289 12.7279 9.81459 12.7373 9.86719C12.745 9.91035 12.75 9.95462 12.75 10C12.75 10.045 12.7449 10.089 12.7373 10.1318C12.7279 10.1845 12.713 10.2361 12.6924 10.2861C12.6803 10.3153 12.6639 10.342 12.6484 10.3691C12.616 10.4261 12.5789 10.4817 12.5303 10.5303L9.53027 13.5303C9.23738 13.8232 8.76262 13.8232 8.46973 13.5303C8.17683 13.2374 8.17683 12.7626 8.46973 12.4697L10.1895 10.75H3C2.58579 10.75 2.25 10.4142 2.25 10C2.25 9.58579 2.58579 9.25 3 9.25H10.1895L8.46973 7.53027C8.17683 7.23738 8.17683 6.76262 8.46973 6.46973Z"
            fill="currentColor"
        />
    </svg>
</template>
